import Navbar from './Navbar';
import Footer from './Footer';
import CookieConsent from './CookieConsent';
import NewsletterPopup from './NewsletterPopup';

export default function Layout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1 pt-16">
        {children}
      </main>
      <Footer />
      <CookieConsent />
      <NewsletterPopup />
    </div>
  );
}
